import { LoteImunobiologicoQuery } from 'graphql/types.generated'

export const covidImunosRecord: Record<string, string> = {
  '85': 'ASTRAZENECA',
  '86': 'SINOVAC LIFE SCIENCE CO., LTD',
  '87': 'PFIZER-BELGICA',
  '88': 'JANSSEN',
  '99': 'BIONTECH',
  '89': 'ASTRAZENECA',
  '95': 'GAMALEYA-SPUTNIK-V',
  '96': 'BHARAT',
  '97': 'MODERNA BIOTECH',
  '98': 'SINOVAC LIFE SCIENCE CO., LTD',
  '102': 'BIONTECH',
  '103': 'PFIZER-BELGICA',
  '105': 'MODERNA BIOTECH',
  '112': 'SERUM-INDIA',
  '114': 'BEIJING',
}

export type LoteImunobiologicoModel = LoteImunobiologicoQuery['lotesImunobiologico']['content'][0]
